<div mat-dialog-title>
    <h6>QR Roadbook</h6>
</div>
<div mat-dialog-content class="border-top border-bottom p-0">
    <qrcode #code [qrdata]="value" size="512" scale="10"></qrcode>
</div>
<div mat-dialog-actions>
    <button class="btn btn-success" (click)="saveAsImage(code)">Download</button>
    <button style="margin-left: 20px" (click)="cancel()" class="btn btn-danger">Close</button>
</div>